import {
  UPLOADER_STATUS_COMPLETED,
  UPLOADER_STATUS_UPLOADING,
  UPLOADER_STATUS_WAITING,
  type UploaderState,
} from '@iconik-io/uploader/src/state';

import type { BadgeType } from '../../components/sidebar_menu/badge';
import { getPathFromParts, getPathParts } from '../../ducks/uploader/helpers';
import type { AppState } from '../../store/types';

export const getUploadingBadge = (uploads: UploaderState[]): BadgeType => {
  if (uploads.length === 0) {
    return 0;
  }
  const finished = uploads.filter(
    (upload) => upload.status === UPLOADER_STATUS_COMPLETED,
  ).length;
  if (finished === uploads.length && finished !== 0) {
    return 'checkmark';
  }
  return uploads.filter(
    (upload) =>
      upload.status === UPLOADER_STATUS_UPLOADING ||
      upload.status === UPLOADER_STATUS_WAITING,
  ).length;
};

export const getUploaderFilePath = (
  state: AppState,
  upload: UploaderState,
): string | undefined => {
  const fileCollections = state.uploaderCollections[upload.id];
  const reflectDirectories = state.uploaderReducer.reflectDirectories;
  const collectionsEntities = state.entities.collections;
  let title;
  if ((fileCollections && fileCollections.length) || reflectDirectories) {
    // for files in collections set the path or the collection title if it's root
    // for root uploads set fullPath if reflectDirectories
    const parent = fileCollections ? fileCollections[0] : undefined;
    title = parent
      ? parent.path || collectionsEntities[parent.id]?.title
      : getPathFromParts(
          getPathParts({
            id: upload.id,
            fullpath: state.uploaderItems[upload.id]?.fullpath,
          }),
        );
    return title;
  }
  return title;
};

export const getAsset = (state: AppState, id?: string) =>
  id ? state.entities.assets[id] : undefined;

export const getCollection = (state: AppState, id?: string) =>
  id ? state.entities.collections[id] : undefined;

export const getEntity = (state: AppState, id?: string) =>
  getAsset(state, id) ?? getCollection(state, id);
